import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faImage, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import MessageForm from "./components/MessageForm";
import InfoModal from "../../../shared/components/InfoModal";
import { API_CHECKOUT } from "../../../shared/services/checkout";
import { API_FINANZAS } from "../../../shared/services/finanzas";
import { useDispatch } from "react-redux";

export default function Transferencias({
    presupuestos, 
    onDoneAction
}) {
    const dispatch = useDispatch();
    const [currentCheckoutId, setCheckoutId] = useState(null);
    const [isView, setIsView] = useState(null); 
    const [isDenied, setIsDenied] = useState(false);

    const showImage = async(comprobante, id) => { 
        dispatch({type: 'loading/set', payload: true});
        const comprobanteResult = await API_FINANZAS.getComprobante(comprobante);

        if(comprobanteResult) {
            setIsView(id);
            
            window.open(comprobanteResult.data, "_blank");
        } else {
            toast.error('Ups! Algo ha ido mal...')
        }
        dispatch({type: 'loading/set', payload: false});
    };

    const handleApproval = async (checkoutId, aprobado) => {
        dispatch({ type: "loading/set", payload: true });
        const checkoutInfo = await API_CHECKOUT.getCheckoutInfo(checkoutId);
        dispatch({ type: "loading/set", payload: false });

        const codigoPedido = checkoutInfo?.data?.item?.presupuesto?.codigo_pedido;
        const plataformaId = checkoutInfo?.data?.item?.presupuesto?.plataforma_id;
        
        dispatch({ type: "loading/set", payload: true });
        const response = await API_CHECKOUT.transferCheckoutDone(checkoutId, {
            aprobado: aprobado,
            codigo_pedido: codigoPedido,
            plataforma_id: plataformaId,
        });
        dispatch({ type: "loading/set", payload: false });

        if (response && response.success) {
            toast.success(response.message);
            onDoneAction(currentCheckoutId);
        }
    };

    const handleOpenDenied = (checkoutId) => {
        setCheckoutId(checkoutId);
        setIsDenied(true);
    }

    const handleDenied = async(data) => {
        dispatch({type: 'loading/set', payload: true});
        const response = await API_CHECKOUT.transferCheckoutDenied(currentCheckoutId, data);

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            onDoneAction(currentCheckoutId);
            setCheckoutId(null);
            setIsDenied(false);
        }
    }

    return (
        <div className="w-100 mt-3">
            <div className="w-100 table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th>comprobante</th>
                            <th>presupuesto</th>
                            <th>total IVA</th>
                            <th className="text-center" width="6%">acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                    { presupuestos?.map((presupuesto, i) => {
                        return (
                            <tr key={'approval-' +  presupuesto.id}>
                                <td>
                                    <span title="Ver comprobante" style={{ cursor: 'pointer' }}>
                                        <FontAwesomeIcon icon={faImage} size="1x" className="action" onClick={() => showImage(presupuesto.comprobante_img, presupuesto.id)} color="#215732" />
                                    </span> 
                                </td>
                                <td>
                                    <span className="fw-bold">{presupuesto.numero}</span>
                                </td>
                                <td>{presupuesto.total_iva}€</td>
                                <td className="text-center">
                                    { isView === presupuesto.id &&
                                        <div className="d-flex align-items-center justify-content-center">
                                            <span title="Aceptar" style={{ cursor: 'pointer' }} className="me-2">
                                                <FontAwesomeIcon icon={faCheckCircle} size="1x" className="action" onClick={() => handleApproval(presupuesto.checkout_id, true)} color="#215732" />
                                            </span> 

                                            <span title="Rechazar" style={{ cursor: 'pointer' }}>
                                                <FontAwesomeIcon icon={faTimesCircle} size="1x" className="action" onClick={() => handleOpenDenied(presupuesto.checkout_id)} color="#dc3545" />
                                            </span> 
                                        </div>
                                    }
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            { isDenied &&
                <InfoModal
                    state={isDenied}
                    title="Aprobación de transferencia cancelada"
                    content={
                        <MessageForm 
                            checkoutId={currentCheckoutId}
                            onSubmitMessage={handleDenied} />
                    }
                    width={'sm'}
                    onClose={() => { setIsDenied(false); }}
                ></InfoModal>
            }
        </div>
    )
}